import React from 'react';
import { TableProps } from 'tea-component';
import BaseMetricsTable, { IBaseMetricsTableCommonProps } from '../BaseTable';
import { getStudioFinancialMetricsColumns } from '../../utils/columns';

import type { IBaseProps } from '@home/types/common';
import type { IMetricsStudioFinancialMetric } from '@gp/types/metrics';

interface IStudioFinancialMetricsTableProps
  extends IBaseProps,
  Omit<TableProps, 'verticalTop' | 'addons' | 'columns' | 'recordKey' | 'records'>,
  IBaseMetricsTableCommonProps<IMetricsStudioFinancialMetric> {
  keyword?: string;
}

const StudioFinancialMetricsTable: React.FC<IStudioFinancialMetricsTableProps> = (props) => {
  const { keyword, ...restProps } = props;

  const columns = getStudioFinancialMetricsColumns({ keyword });

  return (
    <BaseMetricsTable
      {...restProps}
      sortableKeys={['metric', 'data_source', 'update_frequency', 'earliest_data', 'data_latency']}
      columns={columns}
    />
  );
};

export default StudioFinancialMetricsTable;
